import { createFileRoute } from '@tanstack/react-router'
import { MyDayScreen, validateMyDaySearch } from '../features/my-day'

// No loader: the screen renders its own loading, unreachable and offline states (absence is not evidence),
// so a failed read never becomes the router's error page.
export const Route = createFileRoute('/my-day')({
  validateSearch: validateMyDaySearch,
  component: MyDayScreen,
})
